'use strict';

var primaryTabKey = '_we_are_the_borg_';
var bonusTabKey = '_resistance_is_futile_';

module.exports = function detect_multiple_tabs(bonusCallback) {
	// var weArePrimaryTab = ls.get( primaryTabKey ) !== null;
	var tabId = Math.random();
	// ls.set(primaryTabKey, tabId);
	localStorage.setItem(primaryTabKey, tabId);

	const handleStorageEvent = (e) => {
		if (e.key === bonusTabKey) {
			//OH NO! WE'RE THE BONUS TAB! :(
			if (bonusCallback) {
				return bonusCallback();
			}
		}
		if (e.key === primaryTabKey) {
			//this is the primary tab being notified of the bonus tab loading
			//respond and let the bonus tab know what's going on by creating the bonusTabKey
			const newValue = localStorage.getItem(primaryTabKey);
			if (newValue === tabId) {
				//false alarm
				return;
			}
			localStorage.setItem(bonusTabKey, Math.random());
		}
	};

	//just in case *we're* the bonus tab, listen for notification
	window.addEventListener('storage', handleStorageEvent, false);
};
